(function() {
    angular
        .module('emarket.commons')
        .directive('customFieldContainer', ['$mdMedia', function($mdMedia) {
            return {
                scope: {
                    fields: '=',
                    ngModel: '=',
                    hiddenTabs: '=?',
                    edit: '=?'
                },
                templateUrl: function() {
                    var template =
            'directives/custom-fields/custom.fields.container.tpl.html';
                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        template =
              'directives/custom-fields/custom.fields.container.mobile.tpl.html';
                    }
                    return template;
                },

                controller: 'CustomFieldContainerController as vm'
            };
        }]);
}());
